import React, { useEffect, useState, useRef} from 'react';
import { servicesHeroPhoto as HeroTeamImage}  from '../../data/photos';
import { FadeInFromLeft, FadeInFromRightImg } from '../../utils/ServicePageFadeEffects';

export default function ServicesHero() { 
  return (
    <section 
      className="pt-16 md:pt-4 relative w-full min-h-[300px] md:h-[510px] rounded-xl shadow-lg flex flex-col 
      md:flex-row items-center overflow-hidden bg-gradient-to-r from-slate-50 via-blue-100 to-slate-300"
    >
      {/* Text Section 'a' */}
      <div className="z-10 flex-1 flex flex-col justify-center px-6 py-12 md:py-0 md:px-12">
        <FadeInFromLeft delayClass="fade-delay-0">
        <h1 className="text-[2.4rem] lg:text-[2.9rem] font-extrabold leading-tight font-sans mb-4 
        tracking-tight">
          <span className="text-slate-900 ">What we provide?</span>
          <br />
          <span className="text-sky-500">HEALTHCARE</span>
          <br />
          <span className="text-slate-900">and</span>{" "}
          <span className="text-slate-900">Emergency Response.</span>
        </h1>
        <p className="mt-6 text-base md:text-lg font-semibold text-slate-700">
          Reliable, fast, and secure ambulance services powered by next-gen technology.
        </p>
        </FadeInFromLeft>
      </div>

      {/* Fade Transition + Image Section 'b' */}
      <div className="flex-1 relative w-full h-[170px] md:h-full flex items-end justify-end rounded-xl overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-l from-transparent via-blue-100 to-slate-50 pointer-events-none"></div>
          <FadeInFromRightImg
            src={HeroTeamImage}
            alt="Ambulance service team working"
            className="object-cover w-full h-full max-h-[170px] sm:max-h-[230px] md:max-h-none rounded-xl transition-all duration-700 ease-in-out opacity-85 md:opacity-100 md:scale-105 shadow-md"
            style={{
              filter: 'blur(0.5px) brightness(0.98) saturate(1.1)'
            }}
          />
      </div>
    </section>
  );
}
